import React, { Component } from 'react';
import Select from 'react-select';

import { getUser } from '../actions/session';
import axiosInstance from '../config/axiosConfig';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomLoader from '../components/common/loader';
import moment from 'moment';
import Pagination from 'react-js-pagination';
import { Notifications } from '../components/common/notification';
import { USER_CALL_LOGS_URL } from '../config/rest_endpoints';

var firstDate = new Date();
const startT = moment(firstDate.getTime()).subtract(10, 'minutes');

// Custom styles for react-select
const selectStyles = {
    control: (base, state) => ({
        ...base,
        background: 'var(--color-surface)',
        borderColor: state.isFocused ? 'var(--color-primary)' : 'var(--color-border)',
        borderRadius: '10px',
        padding: '0.125rem 0.25rem',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(99, 102, 241, 0.15)' : 'none',
        '&:hover': {
            borderColor: 'var(--color-primary)'
        }
    }),
    option: (base, state) => ({
        ...base,
        background: state.isSelected
            ? 'var(--color-primary)'
            : state.isFocused
                ? 'var(--color-primary-subtle)'
                : 'transparent',
        color: state.isSelected ? 'white' : 'var(--color-text)',
        padding: '0.625rem 1rem',
        cursor: 'pointer'
    }),
    menu: (base) => ({
        ...base,
        borderRadius: '12px',
        boxShadow: 'var(--shadow-lg)',
        border: '1px solid var(--color-border)',
        overflow: 'hidden'
    }),
    singleValue: (base) => ({
        ...base,
        color: 'var(--color-text)'
    }),
    placeholder: (base) => ({
        ...base,
        color: 'var(--color-text-tertiary)'
    })
};

class CdrTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            isGetting: false,
            startDate: startT._d,
            endDate: new Date(),
            selectedtype: { value: 'all', label: 'All' },
            callTypes: [
                { value: 'all', label: 'All' },
                { value: 'successful', label: 'Successful' },
                { value: 'failed', label: 'Failed' }
            ],
            msg: '',
            searchValue: '',
            sourceValue: '', // Added sourceValue to state
            tableData: [],
            activePage: 1,
            itemsCount: 10,
            totalCount: 0,
            isDownloading: false
        };
        this.handleCallType = this.handleCallType.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.getCallLog = this.getCallLog.bind(this);
        this.searchSpace = this.searchSpace.bind(this);
        this.handleSource = this.handleSource.bind(this); // Bind handleSource
        this.handlePageChange = this.handlePageChange.bind(this);
        this.downloadCSV = this.downloadCSV.bind(this);
    }

    componentDidMount() {
        this.getCallLog();
    }

    handleCallType(selectedtype) {
        this.setState({ selectedtype });
    }

    searchSpace(e) {
        this.setState({ searchValue: e.target.value });
    }

    handleSource(e) {
        this.setState({ sourceValue: e.target.value });
    }

    handlePageChange(pageNumber) {
        this.setState(
            {
                activePage: pageNumber
            },
            () => {
                this.getCallLog();
            }
        );
    }

    handleDate(date, value) {
        if (value == 'start') {
            this.setState({ startDate: date });
        } else {
            this.setState({ endDate: date });
        }
    }

    getCallLog() {
        const { User, startDate, endDate, selectedtype, searchValue, sourceValue, itemsCount, activePage } = this.state;
        if (!User || !User.id) return;
        var userID = User.id;
        var payLoad = {
            startDate: moment(startDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
            endDate: moment(endDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
            destination: searchValue,
            source: sourceValue // source is now correctly passed from state
        };
        this.setState({ isGetting: true });
        // Using axiosInstance which automatically adds auth header and handles 401 errors
        axiosInstance.post(`${USER_CALL_LOGS_URL}/${userID}/billing/reports/cdrs?page=${activePage}&limit=${itemsCount}&type=${selectedtype.value}`, payLoad)
            .then((res) => {
                if (res) {
                    var resp = res.data;
                    this.setState({
                        tableData: resp.data,
                        totalCount: resp.pageinfo.totalCount,
                        isGetting: false
                    });
                }
            })
            .catch((err) => {
                this.setState({ isGetting: false });
                // 401/JWT expiry is handled by axiosInstance interceptor
                if (err.response && err.response.status !== 401) {
                    const alert = err.response;
                    if (alert.data && alert.data.message !== 'invalid or expired jwt') {
                        Notifications.notify(alert.data.message, 'Failed', 'error');
                    }
                }
            });
    }

    downloadCSV() {
        const { User, startDate, endDate, selectedtype, searchValue, sourceValue } = this.state;
        if (!User || !User.id) return;
        var userID = User.id;
        var payLoad = {
            startDate: moment(startDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
            endDate: moment(endDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
            destination: searchValue,
            source: sourceValue
        };
        this.setState({ isDownloading: true });
        axiosInstance.post(
            `${USER_CALL_LOGS_URL}/${userID}/billing/reports/cdrs?type=${selectedtype.value}&download=true`,
            payLoad,
            { responseType: 'blob' }
        )
            .then((res) => {
                this.setState({ isDownloading: false });
                const blob = new Blob([res.data], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `cdrs-${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((err) => {
                this.setState({ isDownloading: false });
                if (err.response && err.response.status !== 401) {
                    Notifications.notify('Failed to download CSV', 'Failed', 'error');
                }
            });
    }

    renderCallLogs() {
        const { tableData } = this.state;

        if (tableData == null || tableData.length === 0) {
            return (
                <tr>
                    <td colSpan="9">
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '3rem 1rem',
                                color: 'var(--color-text-tertiary)',
                                animation: 'fadeIn 0.4s ease'
                            }}
                        >
                            <div
                                style={{
                                    width: 64,
                                    height: 64,
                                    borderRadius: '16px',
                                    background: 'var(--color-bg-subtle)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '1rem'
                                }}
                            >
                                <i className="icon-file-empty" style={{ fontSize: '1.5rem', opacity: 0.5 }}></i>
                            </div>
                            <p style={{ margin: 0, fontWeight: 500 }}>No call records found</p>
                            <p style={{ margin: '0.25rem 0 0', fontSize: '0.8125rem' }}>Try adjusting your filters</p>
                        </div>
                    </td>
                </tr>
            );
        }

        return tableData.map((row, idx) => {
            return (
                <tr key={idx}>
                    <td>{row.setupTime ? moment(row.setupTime).format('MMM D, HH:mm:ss') : ''}</td>
                    <td style={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>{row.callID}</td>
                    <td>{row.source === '' ? 'N/A' : row.source}</td>
                    <td style={{ fontWeight: 500 }}>{row.destination}</td>
                    <td style={{ fontFamily: 'monospace', fontSize: '0.8125rem' }}>{row.customerIP}</td>
                    <td>
            <span
                style={{
                    padding: '0.25rem 0.5rem',
                    borderRadius: '6px',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    background: row.hangupCode === '200' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                    color: row.hangupCode === '200' ? '#10B981' : '#EF4444'
                }}
            >
              {row.hangupCode}
            </span>
                    </td>
                    <td style={{ fontSize: '0.8125rem' }}>{row.hangupCause}</td>
                    <td style={{ fontWeight: 600 }}>{row.duration}</td>
                    <td style={{ fontWeight: 600, color: 'var(--color-primary)' }}>{row.billed}</td>
                </tr>
            );
        });
    }

    render() {
        const { callTypes, isGetting, isDownloading, selectedtype, startDate, endDate, searchValue, sourceValue, activePage, itemsCount, totalCount } = this.state;

        return (
            <div style={{ animation: 'fadeInUp 0.5s ease' }}>
                <div className="card" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                    {/* Filters Section */}
                    <div
                        style={{
                            padding: '1.5rem',
                            background: 'var(--color-bg-subtle)',
                            borderBottom: '1px solid var(--color-border)'
                        }}
                    >
                        {/* Date Filters */}
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '1rem',
                                marginBottom: '1rem',
                                padding: '1rem',
                                background: 'var(--color-surface)',
                                borderRadius: '14px',
                                border: '1px solid var(--color-border)'
                            }}
                        >
                            <div style={{ flex: '1 1 200px' }}>
                                <label
                                    style={{
                                        display: 'block',
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        color: 'var(--color-text-secondary)',
                                        marginBottom: '0.5rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}
                                >
                                    Start Date
                                </label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => this.handleDate(date, 'start')}
                                    showTimeSelect
                                    timeFormat="HH:mm:ss"
                                    timeIntervals={15}
                                    timeCaption="time"
                                    dateFormat="MMMM d, yyyy h:mm:ss aa"
                                    className="premium-datepicker"
                                    isClearable
                                    placeholderText="Select start date"
                                    maxDate={new Date()}
                                />
                            </div>
                            <div style={{ flex: '1 1 200px' }}>
                                <label
                                    style={{
                                        display: 'block',
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        color: 'var(--color-text-secondary)',
                                        marginBottom: '0.5rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}
                                >
                                    End Date
                                </label>
                                <DatePicker
                                    name="end"
                                    selected={endDate}
                                    onChange={(date) => this.handleDate(date, 'end')}
                                    showTimeSelect
                                    timeFormat="HH:mm:ss"
                                    timeIntervals={15}
                                    timeCaption="time"
                                    dateFormat="MMMM d, yyyy h:mm:ss aa"
                                    className="premium-datepicker"
                                    isClearable
                                    placeholderText="Select end date"
                                    maxDate={new Date()}
                                />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.5rem' }}>
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={this.getCallLog}
                                    style={{
                                        background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                                        border: 'none',
                                        borderRadius: '10px',
                                        padding: '0.625rem 1.25rem',
                                        color: 'white',
                                        fontWeight: 600,
                                        fontSize: '0.875rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        boxShadow: '0 4px 14px rgba(99, 102, 241, 0.3)',
                                        cursor: 'pointer',
                                        transition: 'all 150ms ease'
                                    }}
                                >
                                    <i className="icon-calendar22"></i>
                                    Filter
                                </button>
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={this.downloadCSV}
                                    disabled={isDownloading}
                                    style={{
                                        background: 'var(--color-surface)',
                                        border: '1px solid var(--color-border)',
                                        borderRadius: '10px',
                                        padding: '0.625rem 1.25rem',
                                        color: 'var(--color-text)',
                                        fontWeight: 600,
                                        fontSize: '0.875rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        cursor: isDownloading ? 'not-allowed' : 'pointer',
                                        opacity: isDownloading ? 0.6 : 1,
                                        transition: 'all 150ms ease'
                                    }}
                                >
                                    {isDownloading ? (
                                        <i className="icon-spinner2 spinner"></i>
                                    ) : (
                                        <i className="icon-download"></i>
                                    )}
                                    {isDownloading ? 'Downloading...' : 'Download CSV'}
                                </button>
                            </div>
                        </div>

                        {/* Search Filters */}
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '1rem',
                                padding: '1rem',
                                background: 'var(--color-surface)',
                                borderRadius: '14px',
                                border: '1px solid var(--color-border)'
                            }}
                        >
                            {/* Added Source Input */}
                            <div style={{ flex: '1 1 200px' }}>
                                <label
                                    style={{
                                        display: 'block',
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        color: 'var(--color-text-secondary)',
                                        marginBottom: '0.5rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}
                                >
                                    Source
                                </label>
                                <input
                                    type="text"
                                    value={sourceValue}
                                    onChange={this.handleSource}
                                    placeholder="Search by source..."
                                    style={{
                                        width: '100%',
                                        padding: '0.625rem 1rem',
                                        borderRadius: '10px',
                                        border: '1px solid var(--color-border)',
                                        background: 'var(--color-surface)',
                                        color: 'var(--color-text)',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.2s ease'
                                    }}
                                />
                            </div>

                            <div style={{ flex: '1 1 200px' }}>
                                <label
                                    style={{
                                        display: 'block',
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        color: 'var(--color-text-secondary)',
                                        marginBottom: '0.5rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}
                                >
                                    Destination
                                </label>
                                <input
                                    type="text"
                                    value={searchValue}
                                    onChange={this.searchSpace}
                                    placeholder="Search by destination..."
                                    style={{
                                        width: '100%',
                                        padding: '0.625rem 1rem',
                                        borderRadius: '10px',
                                        border: '1px solid var(--color-border)',
                                        background: 'var(--color-surface)',
                                        color: 'var(--color-text)',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.2s ease'
                                    }}
                                />
                            </div>
                            <div style={{ flex: '1 1 200px' }}>
                                <label
                                    style={{
                                        display: 'block',
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        color: 'var(--color-text-secondary)',
                                        marginBottom: '0.5rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    }}
                                >
                                    Call Type
                                </label>
                                <Select value={selectedtype} onChange={this.handleCallType} options={callTypes} styles={selectStyles} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={this.getCallLog}
                                    style={{
                                        background: 'var(--color-surface)',
                                        border: '1px solid var(--color-border)',
                                        borderRadius: '10px',
                                        padding: '0.625rem 1.25rem',
                                        color: 'var(--color-text)',
                                        fontWeight: 600,
                                        fontSize: '0.875rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        cursor: 'pointer',
                                        transition: 'all 150ms ease'
                                    }}
                                >
                                    <i className="icon-search4"></i>
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="table-responsive" style={{ padding: '0' }}>
                        <table className="table text-nowrap" style={{ marginBottom: 0 }}>
                            <thead>
                            <tr>
                                {['Start Time', 'Call ID', 'Source', 'Destination', 'Customer IP', 'Hangup Code', 'Hangup Cause', 'Duration', 'Billed'].map(
                                    (header, index) => (
                                        <th
                                            key={header}
                                            style={{
                                                background: 'var(--color-surface)',
                                                color: 'var(--color-text-secondary)',
                                                fontWeight: 600,
                                                fontSize: '0.6875rem',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em',
                                                padding: '1rem 1rem',
                                                borderBottom: '1px solid var(--color-divider)',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {header}
                                        </th>
                                    )
                                )}
                            </tr>
                            </thead>
                            <tbody>{isGetting ? <CustomLoader colSpan={9} message="Loading call records..." /> : this.renderCallLogs()}</tbody>
                        </table>
                    </div>

                    {/* Pagination Footer */}
                    <div
                        style={{
                            padding: '1rem 1.5rem',
                            borderTop: '1px solid var(--color-border)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            gap: '1rem'
                        }}
                    >
                        <div
                            style={{
                                fontSize: '0.8125rem',
                                color: 'var(--color-text-secondary)'
                            }}
                        >
                            Showing <strong>{(activePage - 1) * itemsCount + 1}</strong> to{' '}
                            <strong>{Math.min(activePage * itemsCount, totalCount)}</strong> of <strong>{totalCount}</strong> records
                        </div>
                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={itemsCount}
                            totalItemsCount={totalCount}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                            itemClass="page-item"
                            linkClass="page-link"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default CdrTable;